// extracted by mini-css-extract-plugin
module.exports = {"stickyFooter":"_1uPahye","container":"_26Fd7Yu","left":"_2EKcTex","cta":"_172yUBj","right":"_2v-UOGf","button":"_2nZ8OW2"};